import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Chip,
  Paper,
  Tab,
  Tabs,
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  MenuItem,
  Button,
  Checkbox,
  FormControl,
  Select,
  Menu,
  InputBase,
  TextField,
  InputAdornment,
  useTheme,
} from "@material-ui/core";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import apiConfigs from "../../config/config";
import VisibilityIcon from "@material-ui/icons/Visibility";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import StarIcon from "@material-ui/icons/Star";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import SearchIcon from "@material-ui/icons/Search";
import {
  changePaymentStatus,
  confirmBooking,
  userInvitation,
  changeShiftStatus,
} from "../../store/action";
import history from "../../utils/HistoryUtils";
import Notification from "../../components/Notification/Notification";
import { Email, GetApp } from "@material-ui/icons";

const useStyle = makeStyles((theme) => ({
  viewBtn: {
    display: "flex",
    alignItems: "center",
    width: "max-content",
    cursor: "pointer",
    color: theme.palette.secondary.main,
    gap: 4,
  },

  tabChip: {
    padding: 0,
    margin: 0,
    height: 26,
    "& .MuiChip-label": {
      padding: "0 8px",
      minWidth: 26,
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value != index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value == index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CandidatesList = ({
  bookingDetail,
  booking_id,
  getBookingDetail,
  setConfirmBtn,
  setBookingDetail,
  initialData,
  setCandidateAssignDetails,
  searchingVal,
  setSearchingVal,
  actionType,
}) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElRowInfo, setAnchorElRowInfo] = React.useState(null);
  const [getSigneeid, setGetSigneeid] = React.useState();
  const open = Boolean(anchorEl);
  const [signeeSizeMsg, setSigneeSize] = useState("");
  const [confirmNotify, setConfirmNotify] = useState(false);
  const [selected, setSelected] = React.useState([]);
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const loginDetail = JSON.parse(localStorage.getItem("loginUserInfo"));
  const [localSearch, setLocalSearch] = useState("");
  const { confirmBookingError, invitationSuccess } = useSelector(
    (state) => state.booking
  );
  const theme = useTheme();
  const pastDate = bookingDetail?.data?.is_past;

  const isSelected = (name) => selected.indexOf(name) != -1;
  //old code
  // const [searchingVal, setSearchingVal] = useState("");
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSigneeSize("");
    setSearchingVal("");
    getBookingDetail("", "");
  };

  const [bookingData, setBookingData] = useState({
    booking_id: booking_id,
    signee_id: "",
    status: "",
  });
  const [bookingStatus, setBookingStatus] = useState({
    booking_id: booking_id,
    status: "CONFIRMED",
  });

  const handleMenuItem = (data, anchorElRowInfo) => {
    setBookingData({
      ...bookingData,
      status: data,
      signee_id: anchorElRowInfo?.signeeId,
    });
    if (actionType && actionType === "create") {
      setCandidateAssignDetails(anchorElRowInfo);
    }

    setAnchorEl(null);
  };
  useEffect(() => {
    if (bookingData.status != "" && actionType !== "create") {
      dispatch(
        confirmBooking(bookingData, (result) => {
          if (result?.status == true) {
            dispatch(changeShiftStatus(bookingStatus));
            setTimeout(() => {
              getBookingDetail("", "");
            }, 4000);
          }
        })
      );
      setConfirmNotify(true);
    }
  }, [bookingData]);

  const [bookingApplyData, setBookingApplyData] = useState({
    booking_id: booking_id,
    signee_id: "",
    status: "",
  });
  const handleApplMenuItem = (data, signeeId) => {
    setBookingApplyData({
      ...bookingApplyData,
      status: data,
      signee_id: signeeId,
    });
    setAnchorEl(null);
  };
  useEffect(() => {
    if (bookingApplyData.status != "") {
      dispatch(
        confirmBooking(bookingApplyData, (result) => {
          if (result?.status == true) {
            setTimeout(() => {
              getBookingDetail("", "");
            }, 4000);
          }
        })
      );
      setConfirmNotify(true);
    }
  }, [bookingApplyData]);

  const [pdfData, setPdfData] = useState({
    booking_id: booking_id,
    signee_id: [],
  });

  const [paymentStatus, setPaymentStatus] = useState({
    booking_id: booking_id,
    signee_id: "",
    payment_status: "",
  });

  const handlePaymentStatus = (event, sId) => {
    setPaymentStatus({
      ...paymentStatus,
      [event.target.name]: event.target.value,
      signee_id: sId,
    });
  };

  useEffect(() => {
    if (paymentStatus.payment_status != "") {
      dispatch(changePaymentStatus(paymentStatus));
      setTimeout(() => {
        getBookingDetail("", "");
      }, 4000);
    }
  }, [paymentStatus]);

  const signeePage = (e, signeeId) => {
    e.preventDefault();
    const adminUrl = loginDetail.role == "ORGANIZATION" ? "admin" : "staff";
    history.push(`/${adminUrl.toLowerCase()}/candidate/${signeeId}/detail`);
  };

  const downloadPdf = async () => {
    if (pdfData.signee_id.length == 0) {
      setSigneeSize("Please selected at least one candidate to download pdf");
      return;
    }
    const getToken = localStorage.getItem("token")
      ? localStorage.getItem("token").replace(/['"]+/g, "")
      : "";
    await axios
      .post(`${apiConfigs.API_URL}api/organization/user/pdf`, pdfData, {
        headers: {
          Authorization: getToken ? `Bearer ${getToken}` : "",
        },
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Candidate.pdf");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const handleClose = (data) => {
    setAnchorEl(null);
    setAnchorElRowInfo(null);
  };

  const handleMenu = (event, id, row) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
    setAnchorElRowInfo(row);
    setGetSigneeid(id);
    setConfirmBtn(
      row.status == "CONFIRMED" || row.status == "CREDIT NOTES" ? true : false
    );
  };

  const usersInvitation = () => {
    dispatch(userInvitation(pdfData));
    setConfirmNotify(true);
    setTimeout(() => {
      window.location.reload();
    }, 4000);
  };

  const handleCheckboxClick = (event) => {
    const specialityData = JSON.parse(JSON.stringify(pdfData));
    const isChecked = event.target.checked;
    if (isChecked) {
      specialityData.signee_id.push(parseFloat(event.target.value));
      setPdfData(specialityData);
    } else {
      const newData = specialityData.signee_id.filter(
        (item) => item != parseFloat(event.target.value)
      );
      specialityData.signee_id = newData;
      setPdfData(specialityData);
    }
  };

  useEffect(() => {
    bookingDetail?.data?.matching &&
      bookingDetail?.data?.matching
        .filter((item) => item.signee_booking_status == "CONFIRMED")
        .map((list, index) => {
          return setConfirmBtn(true);
        });
  }, [bookingDetail?.data?.matching]);

  useEffect(() => {
    if (actionType === "view") {
      if (localSearch.length >= 0) {
        const filtered =
          initialData &&
          initialData?.data?.matching?.filter((item) => {
            const {
              first_name,
              last_name,
              email,
              contact_number,
              signee_booking_status,
            } = item;
            const searchQuery = localSearch?.trim().toLowerCase();
            const fullName = `${first_name} ${last_name}`.toLowerCase();
            return (
              fullName?.includes(searchQuery) ||
              email.toLowerCase()?.includes(searchQuery) ||
              contact_number?.includes(searchQuery) ||
              signee_booking_status?.toLowerCase()?.includes(searchQuery)
            );
          });
        if (filtered) {
          setBookingDetail((prevState) => ({
            ...prevState,
            data: {
              ...prevState.data,
              matching: filtered,
            },
          }));
        }
      } else {
        if (initialData) {
          setBookingDetail((prevState) => ({
            ...prevState,
            data: {
              ...prevState.data,
              matching: initialData,
            },
          }));
        }
      }
    }
  }, [localSearch, initialData]);

  useEffect(() => {
    bookingDetail?.data?.interested &&
      bookingDetail?.data?.interested
        .filter((item) => item.signee_booking_status == "CONFIRMED")
        .map((list, index) => {
          return setConfirmBtn(true);
        });
  }, [bookingDetail?.data?.interested]);
  const handleSearchChange = (event) => {
    // const d1 = event.target.value;
    setSearchingVal(event.target.value);

    // getBookingDetail();
  };

  const degreesToRadians = (degrees) => {
    return (degrees * Math.PI) / 180;
  };

  const calculateProximity = (candLat, candLong) => {
    let cliLat = bookingDetail?.data?.latitude;
    let cliLong = bookingDetail?.data?.longitude;
    // console.log("candidate", candLat, candLong);
    // console.log("client", cliLat, cliLong);
    const R = 3958.8; // Earth radius in miles

    if (cliLat && candLat) {
      const dLat = degreesToRadians(cliLat - candLat);
      const dLon = degreesToRadians(cliLong - candLong);

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(degreesToRadians(candLat)) *
        Math.cos(degreesToRadians(cliLat)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c;

      if (distance < 1) {
        return "1 mile away";
      } else {
        return `${distance.toFixed(2)} miles away`;
      }
    } else {
      return "-";
    }
  };


  return (
    <>
      {confirmBookingError && confirmBookingError?.message && (
        <Notification data={confirmBookingError.message} status="error" />
      )}
      {signeeSizeMsg && <Notification data={signeeSizeMsg} status="error" />}
      {confirmNotify && invitationSuccess?.message && (
        <Notification data={invitationSuccess?.message} status="success" />
      )}

      {bookingDetail?.data?.status.replace(/['"]+/g, "") == "CREATED" ? (
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Tabs value={value} onChange={handleChange}>
              <Tab
                label={
                  <Box display="flex" alignItems="center" style={{ gap: "4px" }}>
                    Matching Candidates
                    {bookingDetail?.data?.matching?.length > 0 &&
                      <Chip
                        size="small"
                        label={
                          bookingDetail?.data?.matching?.filter(
                            (item) => item.compliance_status == "COMPLIANT"
                          ).length
                        }
                        color="primary"
                        className={classes.tabChip}
                      />
                    }
                  </Box>
                }
                {...a11yProps(0)}
              />
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={1}>
                    Interested Candidates
                    {bookingDetail?.data?.interested.length > 0 &&
                      <Chip
                        label={bookingDetail?.data?.interested.length}
                        color="primary"
                        className={classes.tabChip}
                      />
                    }
                  </Box>
                }
                {...a11yProps(1)}
              />
            </Tabs>

            <Box display="flex" alignItems="center" style={{ gap: "8px" }}>
              {/* Search box */}
              <Box display="flex" alignItems="center" ></Box>
              <TextField
                size="small"
                placeholder="Search ..."
                name="search"
                variant="outlined"
                onChange={(e) => {
                  actionType !== "view"
                    ? handleSearchChange(e)
                    : setLocalSearch(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ cursor: "pointer" }} />
                    </InputAdornment>
                  ),
                }}
                className="modernSearchField"
              />

              {pdfData.signee_id.length > 0 && bookingDetail?.data?.status == "CREATED" && (
                <Button variant="contained" color="secondary" onClick={usersInvitation}>
                  <Email /> Send invitation
                </Button>
              )}

              {pdfData.signee_id.length > 0 && (
                <Button variant="contained" color="secondary" onClick={downloadPdf}>
                  <GetApp /> Download PDF
                </Button>
              )}
            </Box>
          </Box>

          <Paper elevation={2} style={{ background: theme.palette.background.main }}>
            <TabPanel value={value} index={0}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow style={{ background: theme.palette.thead }}
                  >
                    <TableCell style={{ width: 70, background: theme.palette.thead, color: theme.palette.listItem }}></TableCell>
                    <TableCell style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Id</TableCell>
                    <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Name</TableCell>
                    <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Contact Number</TableCell>
                    <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Email</TableCell>
                    <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Booking Status</TableCell>
                    {/* <TableCell align="left">Proximity</TableCell> */}
                    {bookingDetail?.data?.status == "CONFIRMED" && pastDate && (
                      <TableCell align="left" style={{ background: theme.palette.thead }}>Payment Status</TableCell>
                    )}
                    <TableCell align="left" style={{ background: theme.palette.thead }}>Detail</TableCell>
                    {bookingDetail?.data?.status === "CREATED" &&
                      <TableCell align="right" style={{ background: theme.palette.thead }}>Action</TableCell>
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {bookingDetail?.data?.matching
                    ?.filter((item) => item.compliance_status === "COMPLIANT")
                    .map((row, index) => {
                      isSelected(row.name);
                      return (
                        <TableRow key={index} hover >
                          <TableCell>
                            <Checkbox
                              value={row.signeeId}
                              checked={pdfData.signee_id.includes(row.signeeId)}
                              style={{ color: theme.palette.listItem }}
                              onClick={(event) => handleCheckboxClick(event, row.signeeId)}
                            />
                          </TableCell>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.first_name} {row.last_name}</TableCell>
                          <TableCell>{row.contact_number}</TableCell>
                          <TableCell style={{ wordWrap: "break-word" }}>{row.email}</TableCell>
                          <TableCell>{row.signee_booking_status}</TableCell>
                          <TableCell>
                            <Box
                              style={{ cursor: "pointer" }}
                              onClick={(e) => signeePage(e, row.signeeId)}
                            >
                              <VisibilityIcon fontSize="small" />
                            </Box>
                          </TableCell>
                          {bookingDetail?.data?.status === "CREATED" &&
                            <TableCell align="right">
                              <IconButton onClick={(event) => handleMenu(event, row.signeeId, row)}>
                                <MoreVertIcon />
                              </IconButton>
                            </TableCell>
                          }
                        </TableRow>
                      );
                    })}

                  {bookingDetail?.data?.matching?.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={
                        7 // base columns (Id, Name, Contact, Email, Booking, Detail + checkbox)
                        + (bookingDetail?.data?.status === "CONFIRMED" && pastDate ? 1 : 0) // Payment Status column
                        + (bookingDetail?.data?.status === "CREATED" ? 1 : 0) // Action column
                      } align="center" style={{ padding: "20px" }}>
                        No records found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow style={{ background: theme.palette.thead }}>
                    <TableCell style={{ width: 70, background: theme.palette.thead, color: theme.palette.listItem }}></TableCell>
                    <TableCell style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Id</TableCell>
                    <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Name</TableCell>
                    <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Contact Number</TableCell>
                    <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Email</TableCell>
                    <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Booking Status</TableCell>
                    {(bookingDetail?.data?.status == "CONFIRMED" ||
                      bookingDetail?.data?.status == "CREDIT NOTES") &&
                      pastDate && (
                        <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Payment Status</TableCell>
                      )}
                    <TableCell align="left" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Detail</TableCell>
                    {!pastDate && <TableCell align="right" style={{ background: theme.palette.thead, color: theme.palette.listItem }}>Action</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {bookingDetail?.data?.interested &&
                    bookingDetail?.data?.interested.map((row, index) => {
                      isSelected(row.name);
                      return (
                        <TableRow key={index} hover>
                          <TableCell scope="row">
                            <Checkbox
                              value={row.signeeId}
                              checked={pdfData.signee_id.includes(row.signeeId)}
                              onClick={(event) =>
                                handleCheckboxClick(event, row.signeeId)
                              }
                              className="selectCheckbox"
                              name="signee_id"
                            />
                          </TableCell>
                          <TableCell scope="row">{index + 1}</TableCell>
                          <TableCell align="left">{row.first_name} {row.last_name}</TableCell>
                          <TableCell align="left">{row.contact_number}</TableCell>
                          <TableCell align="left">{row.email}</TableCell>
                          <TableCell align="left">{row.signee_booking_status}</TableCell>
                          {(bookingDetail?.data?.status == "CONFIRMED" ||
                            bookingDetail?.data?.status == "CREDIT NOTES") &&
                            pastDate && (
                              <TableCell align="left">
                                <FormControl variant="standard">
                                  <Select
                                    value={row.payment_status || ""}
                                    name="payment_status"
                                    onChange={(e) =>
                                      handlePaymentStatus(e, row.signeeId)
                                    }
                                    disabled={staffDetail == "Compliance" || staffDetail == "Booking" ? true : false}
                                  >
                                    <MenuItem value="Processed">Processed</MenuItem>
                                    <MenuItem value="Pending">Pending</MenuItem>
                                    <MenuItem value="ONHOLD">On Hold</MenuItem>
                                  </Select>
                                </FormControl>
                              </TableCell>
                            )}

                          <TableCell align="right">
                            <Box
                              onClick={(e) => signeePage(e, row.signeeId)}
                              className={classes.viewBtn}
                            >
                              <VisibilityIcon />view
                            </Box>
                          </TableCell>

                          {row.signee_booking_status != "REJECTED" &&
                            row.signee_booking_status != "CANCEL" ? (
                            !pastDate && (
                              <TableCell align="right">
                                <IconButton
                                  onClick={(event) =>
                                    handleMenu(event, row.signeeId, row)
                                  }
                                >
                                  <MoreVertIcon />
                                </IconButton>
                              </TableCell>
                            )
                          ) : (
                            <TableCell align="right">
                              <IconButton disabled>
                                {/* <RemoveIcon /> */}
                              </IconButton>
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}

                  {bookingDetail?.data?.interested.length == 0 && (
                    <TableRow>
                      <TableCell colSpan={
                        7 // base columns (Id, Name, Contact, Email, Booking, Detail + checkbox)
                        + (bookingDetail?.data?.status === "CONFIRMED" && pastDate ? 1 : 0) // Payment Status column
                        + (!pastDate ? 1 : 0) // Action column
                      } align="center">
                        No records found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TabPanel>
          </Paper>
        </>
      ) : (
        //for only completed tab
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Tabs value={value} onChange={handleChange}>
              <Tab
                label={
                  <Box display="flex" alignItems="center" style={{ gap: "4px" }}>
                    Candidates{" "}
                    {bookingDetail?.data?.confirmed.length > 0 &&
                      <Chip
                        label={
                          bookingDetail?.data?.confirmed.filter(
                            (item) => item.compliance_status == "COMPLIANT"
                          ).length
                        }
                        color="primary"
                        className={classes.tabChip}
                      />}
                  </Box>
                }
                {...a11yProps(0)}
              />
            </Tabs>

            {pdfData.signee_id.length > 0 && (
              <Button variant="contained" color="secondary" onClick={downloadPdf} className={classes.downloadButton}>
                <GetApp /> Download PDF
              </Button>
            )}
          </Box>

          <Paper elevation={2}>
            <TabPanel value={value} index={0}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: 70 }}></TableCell>
                    <TableCell>Id</TableCell>
                    <TableCell align="left">Name</TableCell>
                    <TableCell align="left">Contact Number</TableCell>
                    <TableCell align="left">Email</TableCell>
                    <TableCell align="left">Booking Status</TableCell>
                    {bookingDetail?.data?.status == "CONFIRMED" && pastDate && (
                      <TableCell align="left">Payment Status</TableCell>
                    )}
                    <TableCell align="left">Detail</TableCell>
                    {!pastDate && (
                      <TableCell align="right">Action</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {bookingDetail?.data?.confirmed
                    ?.filter((item) => item.compliance_status == "COMPLIANT")
                    .map((row, index) => {
                      isSelected(row.name);
                      return (
                        <TableRow key={index}>
                          <TableCell scope="row">
                            <Checkbox
                              value={row.signeeId}
                              checked={pdfData.signee_id.includes(row.signeeId)}
                              onClick={(event) =>
                                handleCheckboxClick(event, row.signeeId)
                              }
                              className="selectCheckbox"
                            />
                          </TableCell>
                          <TableCell scope="row">{index + 1}</TableCell>
                          <TableCell align="left">{row.first_name} {row.last_name}</TableCell>
                          <TableCell align="left">{row.contact_number}</TableCell>
                          <TableCell align="left">{row.email}</TableCell>
                          <TableCell align="left">{row.signee_booking_status}</TableCell>
                          {(bookingDetail?.data?.status == "PROVISIONAL" ||
                            bookingDetail?.data?.status == "CONFIRMED") &&
                            pastDate && (
                              <TableCell align="left">
                                <FormControl variant="standard">
                                  <Select
                                    value={row.payment_status || ""}
                                    name="payment_status"
                                    onChange={(e) =>
                                      handlePaymentStatus(e, row.signeeId)
                                    }
                                    disabled={
                                      staffDetail == "Compliance" || staffDetail == "Booking" ? true : false
                                    }
                                  >
                                    <MenuItem value="Processed">Processed</MenuItem>
                                    <MenuItem value="Pending">Pending</MenuItem>
                                    <MenuItem value="ONHOLD">On Hold</MenuItem>
                                  </Select>
                                </FormControl>
                              </TableCell>
                            )}

                          <TableCell align="right">
                            <Box
                              onClick={(e) => signeePage(e, row.signeeId)}
                              className={classes.viewBtn}
                            >
                              <VisibilityIcon className="mr-2" />view
                            </Box>
                          </TableCell>
                          {row.signee_booking_status != "REJECTED" &&
                            row.signee_booking_status != "CANCEL" ? (
                            !pastDate && (
                              <TableCell align="right">
                                <IconButton
                                  onClick={(event) =>
                                    handleMenu(event, row.signeeId, row)
                                  }
                                >
                                  <MoreVertIcon />
                                </IconButton>
                              </TableCell>
                            )
                          ) : (
                            <TableCell align="right">
                              <IconButton disabled>
                                {/* <RemoveIcon /> */}
                              </IconButton>
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}

                  {bookingDetail?.data?.confirmed.length == 0 && (
                    <TableRow>
                      <TableCell colSpan={
                        7 + (bookingDetail?.data?.status == "CONFIRMED" && pastDate ? 1 : 0)
                        + (!pastDate ? 1 : 0)
                      } align="center">
                        No records found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TabPanel>
          </Paper>
        </>
      )}

      {
        anchorEl && (
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={open}
            onClose={handleClose}
          >
            {actionType !== "create" &&
              anchorElRowInfo.signee_booking_status == "PENDING" && (
                <MenuItem
                  onClick={() => handleMenuItem("OFFER", anchorElRowInfo)}
                  className={classes.menuItem}
                >
                  <CheckIcon className="mr-2" />
                  Offer
                </MenuItem>
              )}
            {actionType !== "create" &&
              anchorElRowInfo.signee_booking_status != "CONFIRMED" &&
              anchorElRowInfo.signee_booking_status == "ACCEPT" && (
                <MenuItem
                  onClick={() => handleMenuItem("CONFIRMED", anchorElRowInfo)}
                  className={classes.menuItem}
                >
                  <CheckIcon className="mr-2" />
                  Confirm
                </MenuItem>
              )}
            {anchorElRowInfo.signee_booking_status != "APPLY" &&
              // anchorElRowInfo.signee_booking_status != "OFFER" &&
              // anchorElRowInfo.signee_booking_status != "CONFIRMED" &&
              anchorElRowInfo.signee_booking_status != "REJECTED" && (
                <MenuItem
                  onClick={() => {
                    handleMenuItem("CONFIRMED", anchorElRowInfo);
                    if (actionType === "create") {
                      localStorage.setItem(
                        "sapId",
                        JSON.stringify(anchorElRowInfo || "{}")
                      );
                    }
                  }}
                  className={classes.menuItem}
                >
                  <StarIcon className="mr-2" />
                  Super Assign
                </MenuItem>
              )}
            {actionType !== "create" &&
              anchorElRowInfo.signee_booking_status != "CONFIRMED" &&
              anchorElRowInfo.signee_booking_status == "APPLY" && (
                <MenuItem
                  onClick={() =>
                    handleApplMenuItem("CONFIRMED", anchorElRowInfo.signeeId)
                  }
                  className={classes.menuItem}
                >
                  <StarIcon className="mr-2" />
                  Accept
                </MenuItem>
              )}
            {actionType !== "create" &&
              anchorElRowInfo.signee_booking_status != "REJECTED" && (
                <MenuItem
                  onClick={() => handleMenuItem("REJECTED", anchorElRowInfo)}
                  className={classes.menuItem}
                >
                  <CloseIcon className="mr-2" />
                  Reject
                </MenuItem>
              )}
          </Menu>
        )
      }
    </>
  );
};

export default CandidatesList;
